import { render, staticRenderFns } from "./html-embed.vue?vue&type=template&id=088a7bc6"
import script from "./html-embed.vue?vue&type=script&lang=js"
export * from "./html-embed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports